// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;Yet their sound has gone out into all lands&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and their words to the ends of the world.<br> </p> </div></div>";
// Exports
module.exports = code;